import { Component } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { FormLoading } from '../../forms/base-form/base-form.component';

@Component({
  selector: 'app-date-range-modal',
  templateUrl: './date-range-modal.component.html',
  styleUrls: ['./date-range-modal.component.scss'],
})
export class DateRangeModalComponent extends BaseModalComponent {
  public handleSubmit({ values, formLoading }: { values: any; formLoading: FormLoading }) {
    try {
      this.startLoading();
      formLoading.start();

      // TODO: add logic

      formLoading.stop();
      this.stopLoading();
      this.close(values);
    } catch (err) {
      formLoading.stop();
      this.stopLoading();
    }
  }
}
